export default __webpack_public_path__ + "static/media/Chargers.94295c3f.png";